module.exports = __webpack_public_path__ + "media/images/icons/icon-sold-stats-d954242de3a9388609d924e18a466d92.svg";